/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
  'sidebar.smartstock': 'Smart  Stock',
  'sidebar.divisionesTiposPropiedades': 'Divisiones  Tipos  Propiedades',
  'divisionesTiposPropiedades.agregarDivisiones Tipos Propiedades': 'Create Divisiones  Tipos  Propiedades',
  'divisionesTiposPropiedades.modificarDivisiones Tipos Propiedades': 'Edit Divisiones  Tipos  Propiedades',
  'divisionesTiposPropiedades.eliminarDivisiones Tipos Propiedades': 'Delete Divisiones  Tipos  Propiedades',
  'divisionesTiposPropiedades.divisionTipoPropiedadId': 'Division   Tipo   Propiedad   Id ',
  'divisionesTiposPropiedades.empresaId': ' Empresa   Id ',
  'divisionesTiposPropiedades.divisionTipoPropiedadDescripcion': 'Description',
  'divisionesTiposPropiedades.estado': ' Estado',
  'divisionesTiposPropiedades.divisiones Tipos Propiedades': 'Divisiones  Tipos  Propiedades',
  'divisionesTiposPropiedades.verDivisiones Tipos Propiedades': 'View Divisiones  Tipos  Propiedades',
  'divisionesTiposPropiedades.propiedad': 'Property',
  'divisionesTiposPropiedades.duplicado': 'The property is already registered, please check.',
};
